import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';

import OrderSummaryConnector from '../../containers/order/summary-connector';
import Stepper from './stepper/stepper';
import Step from './stepper/step';
import { ExtraTimeModal } from './modals';
import styles from '../styles/components/checkout-steps/base-checkout-layout.scss';

class BaseCheckoutLayout extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            showModalExtraTime: false,
        };
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if (nextProps.hasExtraTimeCheckout !== this.props.hasExtraTimeCheckout) {
            this.setState((prevState) => ({
                ...prevState,
                showModalExtraTime: nextProps.hasExtraTimeCheckout,
            }));
        }
    }

    isFormLegendRequired() {
        const requiredFor = ['address', 'payment'];
        return this.props.currentStep && requiredFor.indexOf(this.props.currentStep) > -1;
    }

    /*
    This function iterates over all the steps and calls another function for
    generating markup for each step.
  */
    __generateCheckoutStepsMarkup(currentStep, order) {
        if (currentStep === 'complete') {
            this.__generateMarkupForStep(currentStep, currentStep, currentStep, order);
        } else {
            this.props.checkoutSteps.forEach((checkoutStep) => {
                this.__generateMarkupForStep(currentStep, checkoutStep, checkoutStep, order);
            });
        }
    }

    /*
    This function generates two things, namely, the title section for each
    checkout step and the content for the checkout step body (actual form).
    It then pushes the result into +checkoutStepsMarkup+.
  */
    __generateMarkupForStep(currentStep, thisStep, title, order) {
        thisStep = thisStep.trim();

        /* const thisStepIndex = order.checkout_steps.indexOf(thisStep);
        const orderStateIndex = order.checkout_steps.indexOf(order.state); */

        const innerHtml = this.__generateMarkupForStepBody(currentStep, thisStep);

        const formattedTitle = <FormattedMessage id={title.toLowerCase()} defaultMessage={title} />;

        this.checkoutStepsMarkup.push(
            <div className="checkout-block-container checkout-title-block" key={`${thisStep}-step`}>
                {currentStep === thisStep && (
                    <h4 id={`${thisStep.trim()}-section`} className="section-heading">
                        {formattedTitle}
                        { thisStep.trim() === 'delivery' && (
                            <div className={styles.delivery_small_text} style={{ paddingTop: '10px' }}>
                                <FormattedMessage
                                    id="delivery.small.text"
                                    defaultMessage="Choose a delivery method. If a package can be merged in a single shipment we'll do it when you click 'Continue'"
                                />
                            </div>
                        )}
                    </h4>
                )}
                {innerHtml}
            </div>,
        );
    }

    /*
    This generates mark up for step body(form fields for the step etc) if the
    +thisStep+ is same as the +currentStep+. It doesn't generate markup for the
    step title.
  */
    __generateMarkupForStepBody(currentStep, thisStep) {
        if (currentStep === thisStep) {
            return <div className="checkout-block-content">{this.props.children}</div>;
        }
        return null;
    }

    render() {
        const handleCloseModal = () => {
            this.setState({
                showModalExtraTime: false,
            });
        };
        this.checkoutStepsMarkup = [];
        this.__generateCheckoutStepsMarkup(this.props.currentStep, this.props.order);
        return (
            <div className="checkout-flow checkout-section">
                <div className="container">
                    <div className="row">
                        <div className="col-sm-8">
                            <div className="row">
                                <div className="col-sm-12">
                                    <Stepper>
                                        {this.props.order.checkout_steps.map((name, index) => (
                                            <Step
                                                key={index}
                                                title={name}
                                                isComplete={this.props.order.checkout_steps.indexOf(this.props.currentStep) > this.props.order.checkout_steps.indexOf(name)}
                                                isActive={this.props.order.checkout_steps.indexOf(this.props.currentStep) === this.props.order.checkout_steps.indexOf(name)}
                                            />
                                        ))}
                                    </Stepper>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-12">{this.checkoutStepsMarkup}</div>
                            </div>
                            {this.isFormLegendRequired() && (
                                <div className="form-legend">
                                    <FormattedMessage id="legend-required-field" defaultMessage="* indicates the field is required" />
                                </div>
                            )}
                        </div>
                        <div className="col-sm-3 col-sm-offset-1 checkout-block-summary">
                            <OrderSummaryConnector placedOrder={this.props.placedOrder} />
                        </div>
                    </div>
                </div>
                {this.props.gracePeriod && this.props.locale
                && (<ExtraTimeModal gracePeriod={this.props.gracePeriod} locale={this.props.locale} show={this.state.showModalExtraTime} onHide={handleCloseModal} />)}
            </div>
        );
    }
}

export default BaseCheckoutLayout;



/** WEBPACK FOOTER **
 ** ./src/components/checkout-steps/base-checkout-layout.jsx
 **/